// extracted by mini-css-extract-plugin
module.exports = {"train":"Train_train__U6Wcw","train__wrap":"Train_train__wrap__2G1ft","train__address":"Train_train__address__1O6Qy","train__status":"Train_train__status__YDylZ"};